import React, { useState, useEffect } from 'react';
import {
  HomeIcon,
  MapPinIcon,
  DocumentTextIcon,
  UserGroupIcon,
  BuildingOfficeIcon,
  MapIcon,
  ArrowRightOnRectangleIcon,
  CalendarDaysIcon,
  UserIcon
} from '@heroicons/react/24/outline';
import VardiyaYonetimi from './VardiyaYonetimi';
import Acenteler from './Acenteler';
import TransferPlani1 from './TransferPlani1';
import RaporArsiv from './RaporArsiv';

const Dashboard = ({ user, onLogout }) => {
  const [activePage, setActivePage] = useState('Anasayfa');
  const [currentDate, setCurrentDate] = useState(new Date());

  // Role display function - removed as not used currently

  const menuItems = [
    { id: 'Anasayfa', name: 'Anasayfa', icon: HomeIcon },
    { id: 'Vardiya Yönetimi', name: 'Vardiya Yönetimi', icon: UserGroupIcon },
    { id: 'Transfer Planı', name: 'Transfer Planı', icon: MapPinIcon },
    { id: 'Acenteler', name: 'Acente&Birimler', icon: BuildingOfficeIcon },
    { id: 'Rapor & Arşiv', name: 'Rapor & Arşiv', icon: DocumentTextIcon },
    { id: 'Canlı Takip', name: 'Canlı Takip', icon: MapIcon },
  ];

  // Tarih ve saat güncellemesi için useEffect
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentDate(new Date());
    }, 1000); // Her saniye güncelle

    return () => clearInterval(timer);
  }, []);

  // Saati formatla
  const formatTime = (date) => {
    return date.toLocaleTimeString('tr-TR', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
  };

  // Tarihi Türkçe formatta göstermek için yardımcı fonksiyon
  const formatDate = (date) => {
    const options = { 
      weekday: 'long', 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    };
    return date.toLocaleDateString('tr-TR', options);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('role');
    if (onLogout) {
      onLogout();
    }
  };

  const renderPageContent = () => {
    switch (activePage) {
      case 'Anasayfa':
        return (
          <div className="p-8 flex flex-col items-center justify-center min-h-full">
            {/* Hoş Geldiniz ve Tarih Bilgisi */}
            <div className="text-center mb-12">
              <div className="mb-6">
                <h2 className="text-4xl md:text-5xl font-bold bg-gradient-to-r from-gray-900 via-bht-red to-gray-800 bg-clip-text text-transparent mb-2 animate-fade-in leading-tight py-2">
                  Hoş Geldiniz!
                </h2>
                <p className="text-lg text-gray-600 font-medium">BHT CLINIC - Hastane Transfer Sistemi'ne hoş geldiniz.</p>
              </div>
              
              {/* Tarih ve Saat Bilgisi */}
              <div className="bg-white/80 backdrop-blur-sm border border-gray-200/50 rounded-2xl p-4 inline-block animate-slide-up shadow-lg hover:shadow-xl transition-all duration-300">
                <div className="flex items-center space-x-6">
                  <div className="flex items-center">
                    <CalendarDaysIcon className="w-5 h-5 text-blue-600 mr-3" />
                    <span className="text-gray-900 font-semibold text-lg">{formatDate(currentDate)}</span>
                  </div>
                  
                  <div className="w-px h-6 bg-gray-300"></div>
                  
                  <div className="flex items-center">
                    <svg className="w-5 h-5 text-green-600 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    <span className="text-gray-900 font-semibold text-lg">{formatTime(currentDate)}</span>
                  </div>
                </div>
              </div>
            </div>
            
            {/* Hızlı Erişim Butonları */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
              <button
                onClick={() => setActivePage('Transfer Planı')}
                className="group relative bg-white/80 backdrop-blur-sm border border-gray-200/50 rounded-2xl p-6 hover:bg-white hover:shadow-xl hover:border-gray-300 transition-all duration-300 overflow-hidden"
              >
                <div className="absolute inset-0 bg-gradient-to-r from-blue-500/5 to-blue-600/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                <div className="relative flex items-center">
                  <div className="w-12 h-12 bg-gradient-to-r from-blue-500 to-blue-600 rounded-xl flex items-center justify-center mr-4 group-hover:scale-110 transition-transform duration-300">
                    <MapPinIcon className="w-6 h-6 text-white" />
                  </div>
                  <div className="text-left">
                    <h3 className="font-semibold text-gray-900 group-hover:text-blue-700 transition-colors duration-300">Transfer Planı</h3>
                    <p className="text-sm text-gray-600">Transfer planları oluştur ve yönet</p>
                  </div>
                </div>
              </button>
              
              <button
                onClick={() => setActivePage('Vardiya Yönetimi')}
                className="group relative bg-white/80 backdrop-blur-sm border border-gray-200/50 rounded-2xl p-6 hover:bg-white hover:shadow-xl hover:border-gray-300 transition-all duration-300 overflow-hidden"
              >
                <div className="absolute inset-0 bg-gradient-to-r from-emerald-500/5 to-emerald-600/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                <div className="relative flex items-center">
                  <div className="w-12 h-12 bg-gradient-to-r from-emerald-500 to-emerald-600 rounded-xl flex items-center justify-center mr-4 group-hover:scale-110 transition-transform duration-300">
                    <UserGroupIcon className="w-6 h-6 text-white" />
                  </div>
                  <div className="text-left">
                    <h3 className="font-semibold text-gray-900 group-hover:text-emerald-700 transition-colors duration-300">Vardiya Yönetimi</h3>
                    <p className="text-sm text-gray-600">Şoför vardiya planlaması</p>
                  </div>
                </div>
              </button>
              
              <button
                onClick={() => setActivePage('Acenteler')}
                className="group relative bg-white/80 backdrop-blur-sm border border-gray-200/50 rounded-2xl p-6 hover:bg-white hover:shadow-xl hover:border-gray-300 transition-all duration-300 overflow-hidden"
              >
                <div className="absolute inset-0 bg-gradient-to-r from-indigo-500/5 to-indigo-600/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                <div className="relative flex items-center">
                  <div className="w-12 h-12 bg-gradient-to-r from-indigo-500 to-indigo-600 rounded-xl flex items-center justify-center mr-4 group-hover:scale-110 transition-transform duration-300">
                    <BuildingOfficeIcon className="w-6 h-6 text-white" />
                  </div>
                  <div className="text-left">
                    <h3 className="font-semibold text-gray-900 group-hover:text-indigo-700 transition-colors duration-300">Acente&Birimler</h3>
                    <p className="text-sm text-gray-600">Acente yönetimi</p>
                  </div>
                </div>
              </button>
              
              <button
                onClick={() => setActivePage('Rapor & Arşiv')}
                className="group relative bg-white/80 backdrop-blur-sm border border-gray-200/50 rounded-2xl p-6 hover:bg-white hover:shadow-xl hover:border-gray-300 transition-all duration-300 overflow-hidden"
              >
                <div className="absolute inset-0 bg-gradient-to-r from-violet-500/5 to-violet-600/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                <div className="relative flex items-center">
                  <div className="w-12 h-12 bg-gradient-to-r from-violet-500 to-violet-600 rounded-xl flex items-center justify-center mr-4 group-hover:scale-110 transition-transform duration-300">
                    <DocumentTextIcon className="w-6 h-6 text-white" />
                  </div>
                  <div className="text-left">
                    <h3 className="font-semibold text-gray-900 group-hover:text-violet-700 transition-colors duration-300">Rapor & Arşiv</h3>
                    <p className="text-sm text-gray-600">Raporları görüntüle ve arşivle</p>
                  </div>
                </div>
              </button>
              
              <button
                onClick={() => setActivePage('Canlı Takip')}
                className="group relative bg-white/80 backdrop-blur-sm border border-gray-200/50 rounded-2xl p-6 hover:bg-white hover:shadow-xl hover:border-gray-300 transition-all duration-300 overflow-hidden"
              >
                <div className="absolute inset-0 bg-gradient-to-r from-amber-500/5 to-amber-600/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                <div className="relative flex items-center">
                  <div className="w-12 h-12 bg-gradient-to-r from-amber-500 to-amber-600 rounded-xl flex items-center justify-center mr-4 group-hover:scale-110 transition-transform duration-300">
                    <MapIcon className="w-6 h-6 text-white" />
                  </div>
                  <div className="text-left">
                    <h3 className="font-semibold text-gray-900 group-hover:text-amber-700 transition-colors duration-300">Canlı Takip</h3>
                    <p className="text-sm text-gray-600">Transfer araçlarını canlı takip et</p>
                  </div>
                </div>
              </button>
            </div>
          </div>
        );
      case 'Vardiya Yönetimi':
        return <VardiyaYonetimi />;
      case 'Acenteler':
        return <Acenteler />;
      case 'Transfer Planı':
        return <TransferPlani1 />;
      case 'Rapor & Arşiv':
        return <RaporArsiv />;
      case 'Canlı Takip':
        return (
          <div className="p-8">
            <div className="mb-8">
              <h1 className="text-3xl font-bold bg-gradient-to-r from-gray-900 to-gray-700 bg-clip-text text-transparent mb-2">Canlı Takip</h1>
              <p className="text-gray-600">Transfer araçlarının canlı konum takibi</p>
            </div>
            <div className="bg-white/80 backdrop-blur-sm rounded-2xl shadow-xl border border-gray-200/50 p-8 hover:shadow-2xl transition-all duration-300">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-gradient-to-r from-green-600 to-green-700 rounded-xl flex items-center justify-center mr-4">
                  <MapIcon className="w-6 h-6 text-white" />
                </div>
                <div>
                  <h2 className="text-xl font-bold text-gray-900">Canlı Takip</h2>
                  <p className="text-gray-600">Bu sayfa geliştirme aşamasında...</p>
                </div>
              </div>
            </div>
          </div>
        );
      default:
        return (
          <div className="p-8">
            <div className="mb-8">
              <h1 className="text-3xl font-bold bg-gradient-to-r from-gray-900 to-gray-700 bg-clip-text text-transparent mb-2">Anasayfa</h1>
              <p className="text-gray-600">BHT CLINIC - Hastane Transfer Sistemi'ne hoş geldiniz.</p>
            </div>
            <div className="bg-white/80 backdrop-blur-sm rounded-2xl shadow-xl border border-gray-200/50 p-8 hover:shadow-2xl transition-all duration-300">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-gradient-to-r from-bht-red to-red-600 rounded-xl flex items-center justify-center mr-4">
                  <HomeIcon className="w-6 h-6 text-white" />
                </div>
                <div>
                  <h2 className="text-xl font-bold text-gray-900">Hoş Geldiniz!</h2>
                  <p className="text-gray-600">BHT CLINIC - Hastane Transfer Sistemi'ne hoş geldiniz.</p>
                </div>
              </div>
            </div>
          </div>
        );
    }
  };

  return (
    <div className="flex flex-col h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50">
      {/* Top Navigation Bar */}
      <header className="bg-white/80 backdrop-blur-sm shadow-lg border-b border-gray-200/50">
        <div className="flex items-center justify-between px-6 py-4">
          {/* Left Side - Logo and Navigation */}
          <div className="flex items-center space-x-6">
            {/* Logo */}
            <div className="flex items-center">
              <span className="text-xl font-bold text-bht-red">BHT</span>
              <span className="text-xl font-bold text-bht-gray ml-1">CLINIC</span>
            </div>
            
            {/* Navigation Menu */}
            <nav className="flex items-center space-x-1">
              {menuItems.map((item) => {
                const Icon = item.icon;
                return (
                  <button
                    key={item.id}
                    onClick={() => setActivePage(item.id)}
                    className={`flex items-center px-4 py-2 text-sm font-medium rounded-xl transition-all duration-200 ${
                      activePage === item.id
                        ? 'bg-gradient-to-r from-bht-red to-red-600 text-white shadow-lg'
                        : 'text-gray-700 hover:bg-gradient-to-r hover:from-gray-100 hover:to-gray-200 hover:shadow-md'
                    }`}
                  >
                    <Icon className="h-4 w-4 mr-2" />
                    <span>{item.name}</span>
                  </button>
                );
              })}
            </nav>
          </div>

          {/* Right Side */}
          <div className="flex items-center space-x-4">
            {/* Date Box */}
            <div className="flex items-center bg-gradient-to-r from-blue-50 to-indigo-50 border border-blue-200/50 rounded-xl px-4 py-2 hover:from-blue-100 hover:to-indigo-100 transition-all duration-200 shadow-sm">
              <CalendarDaysIcon className="h-5 w-5 text-blue-600 mr-2" />
              <span className="text-sm font-medium text-blue-700">
                {formatDate(currentDate)}
              </span>
            </div>

            {/* Profile and Logout */}
            <div className="flex items-center space-x-3">
              <div className="w-8 h-8 bg-gradient-to-r from-gray-400 to-gray-600 rounded-full flex items-center justify-center">
                <UserIcon className="h-4 w-4 text-white" />
              </div>
              <span className="text-sm font-medium text-gray-800">
                {user?.name || 'BHT Clinic Admin'}
              </span>
              <button
                onClick={handleLogout}
                className="p-2 rounded-xl hover:bg-gradient-to-r hover:from-red-50 hover:to-red-100 transition-all duration-200 shadow-sm"
              >
                <ArrowRightOnRectangleIcon className="h-5 w-5 text-red-600" />
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* Main Content Area */}
      <main className="flex-1 overflow-y-auto bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50">
        {renderPageContent()}
      </main>
    </div>
  );
};

export default Dashboard;
